import { CircleHelp } from 'lucide-react'
import { Popover, PopoverContent, PopoverTrigger } from '@teach/ui'
import { useMessages } from '@/i18n'
import { messages } from '../messages'

/** Заголовок гайда. На телефоне описание прячется в «?» (по нажатию — всплывашка):
 *  абзац в четыре строки над адресом MCP делал первый экран шумным. С `sm` — как было. */
export const GuideHeading = () => {
  const m = useMessages(messages)
  return (
    <div className="space-y-2">
      {/* На телефоне «?» прижат к правому краю блока, а не висит хвостом за заголовком. */}
      <div className="flex items-start justify-between gap-2 sm:justify-start">
        <h3 className="text-lg font-semibold">{m.guideTitle}</h3>
        <Popover>
          <PopoverTrigger asChild>
            <button
              type="button"
              aria-label={m.guideAbout}
              className="mt-0.5 shrink-0 rounded-full text-muted-foreground transition-colors hover:text-foreground sm:hidden"
            >
              <CircleHelp className="size-5" />
            </button>
          </PopoverTrigger>
          <PopoverContent align="end" className="w-72 text-sm text-muted-foreground">
            {m.guideLead}
          </PopoverContent>
        </Popover>
      </div>
      <p className="hidden text-base text-muted-foreground sm:block">{m.guideLead}</p>
    </div>
  )
}
